// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upload_file {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background-color: white;
  height: auto;
  min-height: 80px;
  width: auto;
  border-style: dashed; /* Set border style to dashed */
  border-color: #d8d7d7; /* Border color */
  border-width: 3px; /* Adjust the width of the dashes */
  padding-left: 20px;
  padding-right: 20px;
}

.center-content {
  padding-top: 60px;
  padding-bottom: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  flex-direction: column;
}

/* Shimmer animation for text */
.shimmer-text {
  position: relative;
  overflow: hidden;
  background: linear-gradient(90deg, #f97316 25%, #fb923c 50%, #f97316 75%);
  background-size: 200% 100%;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  animation: shimmer 2s infinite linear;
  font-weight: 500;
  display: inline-block;
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Alternative shimmer effect for better compatibility */
.shimmer-text-alt {
  position: relative;
  overflow: hidden;
  background: linear-gradient(90deg, #f97316 25%, #fb923c 50%, #f97316 75%);
  background-size: 200% 100%;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  animation: shimmer 2s infinite linear;
  font-weight: 500;
  display: inline-block;
}
`, "",{"version":3,"sources":["webpack://./src/containers/documents/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,oBAAoB,EAAE,+BAA+B;EACrD,qBAAqB,EAAE,iBAAiB;EACxC,iBAAiB,EAAE,mCAAmC;EACtD,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;AACxB;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yEAAyE;EACzE,0BAA0B;EAC1B,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,qCAAqC;EACrC,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,wDAAwD;AACxD;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yEAAyE;EACzE,0BAA0B;EAC1B,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,qCAAqC;EACrC,gBAAgB;EAChB,qBAAqB;AACvB","sourcesContent":[".upload_file {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 8px;\n  background-color: white;\n  height: auto;\n  min-height: 80px;\n  width: auto;\n  border-style: dashed; /* Set border style to dashed */\n  border-color: #d8d7d7; /* Border color */\n  border-width: 3px; /* Adjust the width of the dashes */\n  padding-left: 20px;\n  padding-right: 20px;\n}\n\n.center-content {\n  padding-top: 60px;\n  padding-bottom: 35px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-grow: 1;\n  flex-direction: column;\n}\n\n/* Shimmer animation for text */\n.shimmer-text {\n  position: relative;\n  overflow: hidden;\n  background: linear-gradient(90deg, #f97316 25%, #fb923c 50%, #f97316 75%);\n  background-size: 200% 100%;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  animation: shimmer 2s infinite linear;\n  font-weight: 500;\n  display: inline-block;\n}\n\n@keyframes shimmer {\n  0% {\n    background-position: -200% 0;\n  }\n  100% {\n    background-position: 200% 0;\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Alternative shimmer effect for better compatibility */\n.shimmer-text-alt {\n  position: relative;\n  overflow: hidden;\n  background: linear-gradient(90deg, #f97316 25%, #fb923c 50%, #f97316 75%);\n  background-size: 200% 100%;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  animation: shimmer 2s infinite linear;\n  font-weight: 500;\n  display: inline-block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
